export enum RoutesPaths {
  app = '/',

  // auth = '/auth',
  authLogin = '/',
  authProof = '/proof',
  authConfirmation = '/confirmation',
  authSuccess = '/success',
}
